import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { getCoreAgentToolsSlice } from './get';

export const coreAiAgentToolsReducers = combineReducers({
	get: getCoreAgentToolsSlice.asyncReducers
});

export const coreAiAgentToolsWatchers = combineAllWatchers([
	getCoreAgentToolsSlice.asyncWatchers
]);
